import React, { Component } from 'react';
import { StepPage } from '../../controls/StepPage';
import { EardrumOption } from './EardrumOption';
import orderService from '../OrderService';
import { LeftRightOption } from '../../infrastructure/AppConstants';

export class EarmoldStep3Page extends StepPage {

    constructor(props) {
        super(props);
        this.state = { data: null };
        this.handleEardrumBte = this.handleEardrumBte.bind(this);
        this.handleEardrumRic = this.handleEardrumRic.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        let data = await orderService.populateEarmoldProductOptionData(true);
        this.setState({ data: data });
    }

    handleEardrumBte(e) {
        if (this.props.model) {
            this.props.model.eardrumBte = e;
        }
    }

    handleEardrumRic(e) {
        if (this.props.model) {
            this.props.model.eardrumRic = e;
        }
    }

    validate() {
        let model = this.props.model;
        let type = model.bteOrRic;
        if (type === "BTE") {
            let leftRightOption = this.props.leftRightOption;
            if (leftRightOption === LeftRightOption.LeftEarOption) {
                if (!model.eardrumBte || model.eardrumBte.startsWith("-1")) {
                    return { state: false, msg: "EarmoldTypeTitle" };
                }               
            }
            else if (leftRightOption === LeftRightOption.RightEarOption) {
                if (!model.eardrumBte || model.eardrumBte.endsWith("-1")) {
                    return { state: false, msg: "EarmoldTypeTitle" };
                }               
            }
            else if (leftRightOption === LeftRightOption.BothEarsOption) {
                if (!model.eardrumBte || model.eardrumBte.includes("-1")) {
                    return { state: false, msg: "EarmoldTypeTitle" };
                }                
            }
        }
        if (type === "RIC" || type ==="IF") {
            let leftRightOption = this.props.leftRightOption;
            if (leftRightOption === LeftRightOption.LeftEarOption) {
                if (!model.eardrumRic || model.eardrumRic.startsWith("-1")) {
                    return { state: false, msg: "EarmoldTypeTitle" };
                }                
            }
            else if (leftRightOption === LeftRightOption.RightEarOption) {
                if (!model.eardrumRic || model.eardrumRic.endsWith("-1")) {
                    return { state: false, msg: "EarmoldTypeTitle" };
                }                
            }
            else if (leftRightOption === LeftRightOption.BothEarsOption) {
                if (!model.eardrumRic || model.eardrumRic.includes("-1")) {
                    return { state: false, msg: "EarmoldTypeTitle" };
                }                
            }        
        }
        return { state: true, msg: "todo check page3" };
    }

    render() {
        let data = this.state.data;
        if (!data) {
            return null;
        }

        let model = this.props.model;
        if (!model) {
            return null;
        }
        
        var type = model.bteOrRic;
        if (type === "RIC") {
            return <div className="flex gap-6">
                <EardrumOption earmoldCategory={type} leftRightOption={this.props.leftRightOption} className="border-collapse w-3/4 text-sm" title="RIC" desc="EardrumRicDesc" enclosureTypes={data.ricEnclosureTypes} hardEardrumColorOptions={data.hardEardrumColorOptions}
                        softEardrumColorOptions={data.softEardrumColorOptions} onSelectValueChanged={this.handleEardrumRic} value={model.eardrumRic} />                
            </div>
        }
        else if (type === "IF") {
            return <div className="flex gap-6">
                <EardrumOption earmoldCategory={type} leftRightOption={this.props.leftRightOption} className="border-collapse w-1/4 text-sm" title="IF" desc="EardrumIFDesc" enclosureTypes={data.ricEnclosureTypes} hardEardrumColorOptions={data.hardEardrumColorOptions}
                    softEardrumColorOptions={data.softEardrumColorOptions} onSelectValueChanged={this.handleEardrumRic} value={model.eardrumRic} />
            </div>
        }

        return <div className="flex gap-6">
            
            <EardrumOption earmoldCategory={type} leftRightOption={this.props.leftRightOption} className="border-collapse w-3/4 text-sm" title="BTE" desc="EardrumBteDesc" enclosureTypes={data.bteEnclosureTypes} hardEardrumColorOptions={data.hardEardrumColorOptions}
                    softEardrumColorOptions={data.softEardrumColorOptions} onSelectValueChanged={this.handleEardrumBte} value={model.eardrumBte} />
           
        </div>
    }
}
